import axios from "../axios";
import Cookies from "js-cookie";

// Harshada Bhavsar(4/7/2025)
// Create consultant API call
export const createConsultant = async (formData) => {
  const token = Cookies.get("employeeToken");

  if (!token) {
    throw new Error("Login token missing.");
  }

  const payload = {
    token,
    ...formData,
  };

  return axios.post("/api/Admin/Employee/CreateConsultant", payload);
};
